import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { setSelectedShapeId } from 'store/actions';
import { getShapeById } from './helpers';
import { shapeFields } from './shapeFields';
import VerticalDetailsBox from '../explore/common/VerticalDetailsBox';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  closeShapeIcon: {
    position: 'absolute',
    right: 0,
    top: 0,
    width: 25,
    height: 25,
    'z-index': 1,
    borderRadius: `0px 4px 0px 0px`,
    '&:hover': {
      backgroundColor: 'rgba(212, 212, 212, 1)',
      cursor: `pointer`,
    },
  },
}));

function MapOverlayShapeInfoBox({
  selectedShapeId,
  shapesData,
  setSelectedShapeId,
}) {
  const classes = useStyles();
  const selectedShape = getShapeById(shapesData, selectedShapeId);

  function onClose() {
    setSelectedShapeId(null);
  }

  if (selectedShapeId && selectedShape) {
    return (
      <>
        <VerticalDetailsBox
          contentPadding={10}
          dataItem={selectedShape}
          fields={shapeFields}
          title={selectedShape.GeoName}
        />
        <svg
          height='20'
          width='20'
          className={classes.closeShapeIcon}
          onClick={onClose}
        >
          <path d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z' />
        </svg>
      </>
    );
  } else {
    return <></>;
  }
}

function mapState({ assumptionMapState }) {
  return {
    shapesData: assumptionMapState.shapesData,
    selectedShapeId: assumptionMapState.selectedShapeId,
  };
}

const mapDispatch = {
  setSelectedShapeId,
};

export default compose(connect(mapState, mapDispatch))(MapOverlayShapeInfoBox);
